import { render, staticRenderFns } from "./user_bzzx.vue?vue&type=template&id=182508a4&scoped=true"
import script from "./user_bzzx.vue?vue&type=script&lang=js"
export * from "./user_bzzx.vue?vue&type=script&lang=js"
import style0 from "./user_bzzx.vue?vue&type=style&index=0&id=182508a4&prod&scoped=true&lang=less"
import style1 from "./user_bzzx.vue?vue&type=style&index=1&id=182508a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182508a4",
  null
  
)

export default component.exports